import React from 'react';
import { DefaultButton, FontSizes, Icon, Label, PrimaryButton, Separator, Spinner, SearchBox } from "@fluentui/react"
import { Add24Regular } from '@fluentui/react-icons';
import { connect } from "react-redux";
import { useBoolean } from '@fluentui/react-hooks';
import { ErrorMessageComponent } from "../../../Error/ErrorMessageComponent";
import { useEffect, useState } from "react";
import { ContractConcept } from "../../../../models/Entities/Contracts/ContractConcept";
import ConceptFormComponent from "../ConceptForm/ConceptForm.Component";
import { ConceptItemComponent } from "./ConceptItem.Component";

// functions
import * as ComponentFunctions from './ConceptList.Functions';

////i18Next
import { useTranslation, Trans } from 'react-i18next';

// styles
import './ConceptList.Styles.css';

//image 
const emptyResultImage = '../../../../assets/img/empty_state.gif';



export const ConceptListComponent = (props: ComponentFunctions.Props) => {

    // initial values
    const [isOpenInitialSettings, { setTrue: openPanelInitialSettings, setFalse: dismissPanelInitialSettings }] = useBoolean(false);
    const [selectedConcept, setSelectedConcept] = useState<ContractConcept | undefined>(undefined);
    const [filterText, setFilterText] = useState<string>("");

    // Add or eddit Concept
    const [isOpenVisit, { setTrue: openPanelConcept, setFalse: dismissPanelConcept }] = useBoolean(false);

    const handleInitialSettingsClosePanel = () => {
        dismissPanelInitialSettings();
    };

    const handleConceptClosePanel = () => {
        setSelectedConcept(undefined);
        dismissPanelConcept();
    };

    const handleChargeVisitInformation = () => {
        openPanelInitialSettings();
    };

    const HandleAddEvent = () => {
        openPanelConcept();
    };

    const HandleEditEvent = (concept: ContractConcept) => {
        setSelectedConcept(concept);
        openPanelConcept();
    }

    const HandleDeleteEvent = (concept: ContractConcept) => {
        props.DeleteContractConcept(concept.id, props.ContractId, props.ContractAddendumId);
    }

    //useTransaltion()
    const [t] = useTranslation();

    // efects   
    useEffect(() => {
        if (props.Contract) {
            props.GetAllContractsConceptByAddendum(props.ContractId, props.ContractAddendumId);
        }
    }, [props.Contract === undefined, props.ContractAddendumId]);

    // Loading
    const Loading = props.isLoading && (
        <div>
            <Spinner
                label={t('conceptList.loading.loadingConcepts')}
                ariaLive="assertive"
                labelPosition="top"
            />
        </div>
    );

    const ComponentActions = (
        <div className="ConceptListActions">
            <PrimaryButton
                secondaryText={t('conceptList.componentActions.addConcept')}
                onClick={HandleAddEvent}
                text={t('conceptList.componentActions.addConcept')}
                onRenderIcon={() => <Add24Regular />}
                className="actionButton"
            />
            <SearchBox
                className="conceptSearch"
                placeholder={t('conceptList.search.placeholder', 'Buscar conceptos por nombre, referencia o descripción')}
                value={filterText}
                onChange={(_, newValue) => setFilterText(newValue || "")}
                onClear={() => setFilterText("")}
                styles={{ root: { maxWidth: 380, margin: '8px 0' } }}
            />
        </div>
    )

    const ErrorMessage = props.failOnLoading && props.error && (
        <ErrorMessageComponent Error={props.error} />
    )

    const NoRegistries = (props.isLoadingSuccessfully && props.ContractConcepts?.length === 0 || props.ContractConcepts?.length === undefined) && (
        <div className="NoDataSection">
            <img
                src={require('../../../../assets/img/empty_state.gif')}
                alt="Ichtys"
                style={{ width: '10em', height: '10em', marginBottom: '1em' }}
            ></img>
            <Label>{t('conceptList.noRegistries.noConceptsRegistered.noConceptsRegistered')}</Label>
        </div>
    );

    const Forms = <>
        <ConceptFormComponent 
            isOpen={isOpenVisit}
            openPanel={openPanelConcept}
            dismissPanel={handleConceptClosePanel}
            ContractId={props.ContractId}
            ContractAddendumId={props.ContractAddendumId}
            ContractConceptId={selectedConcept?.id}
            CurrentConcepts={props.Contract?.concepts || []}
            CurrentStages={props.Addendum?.stages || []}
        />
    </>

    const normalized = (v?: string) => (v || "").toString().toLowerCase();
    const term = normalized(filterText);
    const filteredConcepts = term
        ? props.ContractConcepts.filter(cc => {
            const n = normalized(cc.concept?.conceptName);
            const d = normalized(cc.concept?.conceptDescription);
            const r = normalized(cc.concept?.conceptReferenceId as any);
            return n.includes(term) || d.includes(term) || r.includes(term);
        })
        : props.ContractConcepts;


    return (
        <>
            {ComponentActions}
            <Separator />
            {ErrorMessage}
            {props.isLoading ? Loading : null}
            <div className="ci-list">
                {filteredConcepts?.map((concept: ContractConcept, index) => (
                    <ConceptItemComponent
                        Concept={concept} index={index}
                        onEdit={(concept: ContractConcept) => HandleEditEvent(concept)}
                        onDelete={(concept: ContractConcept) => HandleDeleteEvent(concept)}
                        isDeleting={props.isDeleting}
                        failonDeleting={props.failOnDeleting}
                        error={props.error}
                    />
                ))}
            </div>
            {NoRegistries}
            {Forms}
        </>
    )
}

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(ConceptListComponent as any);